/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    class="wordspotting-list"
    aria-label="Wordspotting List"
  >
    <div
      v-for="word in words"
      class="wordspotting-word"
    >
      {{ word }}
    </div>
  </div>
</template>

<style lang="less" scoped>
  .wordspotting-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .wordspotting-word {
    flex-shrink: 0;
    padding: 5px;
    border: 1px solid #666;
    border-radius: 8px;
    margin: 5px;
    background-color: white;
  }
</style>

<script>
export default {
  props: ['words'],
  data() {
    return {};
  }
};
</script>
